import { Link } from 'react-router-dom';
import GallerySection from '../components/GallerySection';

export default function Tagrende() {
  // Optimeret billede til tagrendesiden
  const tagrendeImg = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183611285-ios.jpg';
  const optimizedImg = tagrendeImg.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/');

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Tagrende rens - Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Nygaards Vinduespolering tilbyder tagrende rens, der fjerner blade og snavs og hjælper med bedre vandafledning fra taget."
      />

      {/* Hero Header */}
      <section className="bg-slate-50/70 py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            Vedligeholdelse
          </span>
          <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue sm:text-4xl">
            Tagrende rens
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
            Effektiv og sikker rensning af tagrender, der beskytter dit hus mod fugt- og vandskader.
          </p>
        </div>
      </section>

      {/* Detaljeret Indhold */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
            {/* Tekst */}
            <div className="lg:col-span-7">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Forebyggelse
              </span>
              <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
                Forebyg vandskader med rene tagrender
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                Tilstoppede tagrender kan føre to alvorlige problemer som overløb, fugtskader på facaden, råd i udhæng og i værste fald fugt i fundamentet. Blade, grene, mos og snavs samler sig hurtigt i løbet af året, især i efteråret. Hos Nygaards Vinduespolering tilbyder vi en professionel og grundig rensning af dine tagrender, så vandet igen kan ledes sikkert væk.
              </p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                Vores tagrenderensning er ideel til:
              </p>
              <ul className="mt-4 grid grid-cols-1 gap-3 text-xs font-light text-slate-500 sm:grid-cols-2">
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Private husejere & villaer</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Mindre erhvervsejendomme</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Sommerhuse & fritidshuse</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Etageejendomme & boligforeninger</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Nedløbsrør & tagnedløb</span>
                </li>
              </ul>

              <div className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  Få renset dine tagrender
                </Link>
              </div>
            </div>

            {/* Billede */}
            <div className="lg:col-span-5">
              <div className="relative aspect-4/3 overflow-hidden rounded-none bg-slate-100 shadow-none">
                <img
                  src={optimizedImg}
                  alt="Professionel tagrenderensning i Kerteminde"
                  className="h-full w-full object-cover rounded-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fokusområder */}
      <section className="bg-slate-50/70 py-20 border-t border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Hvorfor rense?
            </span>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-blue">
              Fordelene ved regelmæssig tagrenderensning
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-shield-heart" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Undgå dyre vandskader</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Ved at holde tagrenderne rene forebygger du, at vandet løber over og trænger ind i tagkonstruktionen, facaden eller kælderen.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-droplet-slash" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Optimal vandafledning</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi sikrer, at både tagrender og nedløbsrør er helt fri for forhindringer, så regnvand kan løbe frit og uhindret væk.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-handshake" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Kombiner med vinduespudsning</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Få løst to praktiske opgaver på én gang. Vi renser gerne dine tagrender i forbindelse med den regelmæssige vinduespolering.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Galleri Sektion (Tilkoblet via slug) */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <GallerySection slug="tagrende-rens" />
        </div>
      </section>
    </>
  );
}
